import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Image } from 'lucide-react';
import { FaDiscord, FaTwitter } from 'react-icons/fa';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-page-bg border-b border-border-light">
      <div className="container-custom">
        <div className="flex justify-between items-center h-20">
          <div className="brand-logo">
            <span className="nav-brand-text font-bold text-2xl uppercase tracking-tight">
              Fight for Erebus
            </span>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-6">
            <button onClick={() => scrollToSection('trailer')} className="nav-link">
              Trailer
            </button>
            <button onClick={() => scrollToSection('stats')} className="nav-link">
              Stats
            </button>
            <button onClick={() => scrollToSection('features')} className="nav-link">
              Features
            </button>
            <button onClick={() => scrollToSection('elements')} className="nav-link">
              Elements
            </button>
            <Link to="/gallery" className="nav-link flex items-center gap-1">
              <Image size={16} />
              Gallery
            </Link>
            <button onClick={() => scrollToSection('beta')} className="nav-link">
              Beta Access
            </button>
            
            {/* Social Links */}
            <div className="flex items-center gap-3 ml-2 pl-4 border-l border-border-light">
              <a 
                href="https://discord.gg/NRqFJAx8" 
                target="_blank" 
                rel="noopener noreferrer"
                className="nav-icon hover:text-[#5865F2] transition-colors"
                title="Discord"
                data-testid="social-discord"
              >
                <FaDiscord size={20} />
              </a>
              <a 
                href="https://x.com/FightForErebus" 
                target="_blank" 
                rel="noopener noreferrer"
                className="nav-icon hover:text-white transition-colors"
                title="Twitter/X"
                data-testid="social-twitter"
              >
                <FaTwitter size={18} />
              </a>
            </div>
            
            <button onClick={() => scrollToSection('beta')} className="btn-primary">
              Join Beta
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden nav-icon"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden pb-6 space-y-4">
            <button 
              onClick={() => scrollToSection('trailer')} 
              className="block w-full text-left nav-link"
            >
              Trailer
            </button>
            <button 
              onClick={() => scrollToSection('stats')} 
              className="block w-full text-left nav-link"
            >
              Stats
            </button>
            <button 
              onClick={() => scrollToSection('features')} 
              className="block w-full text-left nav-link"
            >
              Features
            </button>
            <button 
              onClick={() => scrollToSection('elements')} 
              className="block w-full text-left nav-link"
            >
              Elements
            </button>
            <Link 
              to="/gallery" 
              className="flex items-center gap-2 nav-link"
              onClick={() => setIsMenuOpen(false)}
            >
              <Image size={16} />
              Gallery
            </Link>
            <button 
              onClick={() => scrollToSection('beta')} 
              className="block w-full text-left nav-link"
            >
              Beta Access
            </button>
            
            {/* Mobile Social Links */}
            <div className="flex items-center gap-4 py-2">
              <a 
                href="https://discord.gg/NRqFJAx8" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-text-secondary hover:text-[#5865F2] transition-colors"
              >
                <FaDiscord size={24} />
              </a>
              <a 
                href="https://x.com/FightForErebus" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-text-secondary hover:text-white transition-colors"
              >
                <FaTwitter size={22} />
              </a>
            </div>
            
            <button 
              onClick={() => scrollToSection('beta')} 
              className="btn-primary w-full"
            >
              Join Beta
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
